import { ReactComponent as RiAlertLine } from '@/assets/icons/ri-alert-line.svg';
import { ReactComponent as RiBadmintonCourt } from '@/assets/icons/ri-badminton-court.svg';
import { convertToLocalTime } from '@/utils';

const summaryData = (schedules) => {
  const summary = {}
  const hours = {}
  schedules.forEach(schedule => {
    const court = schedule.court.id
    if (hours[court]) { hours[court].push(schedule.hour) }
    else { hours[court] = [schedule.hour] }
    summary[court] = {
      fieldName: schedule.court.code || schedule.court.name,
      hours: hours[court],
      id: schedule.court.id
    }
  })
  return summary
}

const formatBookingHours = (hours: number[]) => {
  const bookedHours = {}
  hours.sort((a, b) => a-b)
  let start = 0
  let end = 0
  let duration = 0
  hours.forEach((hour) => {
    if (hour === end) {
      end+=1
      duration+=1
      bookedHours[start].end = end
      bookedHours[start].duration = duration
    } else {
      start = hour
      end = hour+1
      duration=1
      bookedHours[start] = {
        start,
        end,
        duration
      }
    }
  })
  return bookedHours
}

const calculateBookingDuration = (hours) => {
  let totalDuration = 0
  Object.keys(hours).forEach(duration => {
    totalDuration += hours[duration].duration
  })
  if (totalDuration === 16) {
    return 'Full Day'
  }
  return `${totalDuration} jam`
}

const Summary = ({ selectedSchedules, conflictingSchedules }) => (
  <div className='bg-white p-0'>
    <div className='flex items-start px-8 pt-8 pb-0 gap-3 rounded-t'>
      <p className='font-bold text-lg'>Summary</p>
    </div>
    <div className='flex flex-col items-start p-8 gap-6 rounded-b'>
      {!!conflictingSchedules.length &&
      <div className='flex w-full px-3 py-2.5 gap-2 bg-red-subtle border-l-4 border-red-secondary text-red-secondary'>
        <RiAlertLine />
        <p className='text-sm text-black-primary'>There is a conflicting schedule</p>
      </div>}
      {Object.keys(selectedSchedules).map(date => {
          const summary = summaryData(selectedSchedules[date]);
          return (!!Object.keys(summary).length &&
            <div className='flex flex-col w-full gap-4'>
              <div className='flex py-3 gap-2 bg-grey-subtle border-b border-grey-line-subtle'>
                <p className='pl-2 font-medium text-xs'>{`${new Date(convertToLocalTime(Number(date))).toLocaleString('id-ID', {
                  day: 'numeric',
                  year: 'numeric',
                  month: 'long',
                })}`}</p>
              </div>
              {Object.keys(summary).map(court => {
                const field = summary[court];
                return (
                  <div className='flex px-2 py-0'>
                    <div className='flex justify-between items-center p-0 gap-28'>
                      <div className='flex p-0 gap-4'>
                        <div
                          className='flex flex-col justify-center items-center px-3 py-4 gap-2 bg-green-success rounded text-white'>
                          <RiBadmintonCourt />
                        </div>
                        <div className='flex flex-col justify-center p-0'>
                          <p className='font-medium text-sm'>{`${field.fieldName}`}</p>
                          {Object.keys(formatBookingHours(field.hours)).map(hour => {
                            const { start, end } = formatBookingHours(field.hours)[hour];
                            return (
                              <p className='text-xs text-grey-dark'>({`${start}.00 - ${end}.00`} WIB)</p>
                            );
                          })}
                        </div>
                      </div>
                      <p
                        className='flex justify-end font-bold text-sm'>{calculateBookingDuration(formatBookingHours(field.hours))}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          );
        },
      )}
    </div>
  </div>
)
export default Summary
